import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from '../common/Button';
import { toast } from 'react-toastify';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase'; // Certifique-se de que está importando o Firebase corretamente

function EditEventModal({ isOpen, evento, onClose, onSave }) {
  const [editedEvent, setEditedEvent] = useState({
    descricao: '',
    dataHora: '',
    hora: '',
  });

  // Atualiza o estado do evento quando o prop `evento` muda
  useEffect(() => {
    if (evento) {
      setEditedEvent({
        descricao: evento.descricao || evento.title || '',
        dataHora: evento.data || '', // Considere `evento.data` como a data completa
        hora: evento.hora || '',
      });
    }
  }, [evento]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'dataHora') {
      setEditedEvent((prev) => ({ ...prev, dataHora: value }));
    } else if (name === 'hora') {
      setEditedEvent((prev) => ({ ...prev, hora: value }));
    } else {
      setEditedEvent((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSave = async () => {
    if (editedEvent.descricao && editedEvent.dataHora && editedEvent.hora) {
      try {
        // Atualiza no Firebase
        const eventDocRef = doc(db, 'agenda', evento.id);
        await updateDoc(eventDocRef, {
          descricao: editedEvent.descricao,
          data: editedEvent.dataHora,
          hora: editedEvent.hora,
        });

        onSave({
          ...evento, // Inclui o ID e outros dados não editáveis do evento original
          descricao: editedEvent.descricao,
          data: editedEvent.dataHora,
          hora: editedEvent.hora,
        });
      } catch (error) {
        toast.error('Erro ao atualizar o evento no Firebase.');
        console.error('Erro ao salvar no Firebase:', error);
      }
    } else {
      toast.error('Por favor, preencha todos os campos obrigatórios.');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-600 bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-3xl mx-4">
        <h2 className="font-bold mb-4 text-gray-700">Editar Evento</h2>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Tipo de Evento
          </label>
          <input
            type="text"
            name="tipo"
            value={evento.tipo || ''}
            readOnly
            className="w-full p-2 border border-gray-300 rounded-lg bg-gray-200"
            aria-label="Tipo do evento"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Descrição
          </label>
          <input
            type="text"
            name="descricao"
            value={editedEvent.descricao || ''}
            onChange={handleChange}
            aria-label="Descrição do evento"
            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Data
          </label>
          <input
            type="date"
            name="dataHora"
            value={editedEvent.dataHora || ''}
            onChange={handleChange}
            aria-label="Data do evento"
            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Hora
          </label>
          <input
            type="time"
            name="hora"
            value={editedEvent.hora || ''}
            onChange={handleChange}
            aria-label="Hora do evento"
            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>
        <div className="flex justify-end space-x-4">
          <Button
            type="cancelar"
            label="Cancelar"
            onClick={onClose}
            ariaLabel="Cancelar edição de evento"
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded-3x1 focus:outline-none focus:ring-2 focus:ring-gray-500"
          />
          <Button
            type="salvar"
            label="Salvar"
            onClick={handleSave}
            ariaLabel="Salvar evento editado"
            className="px-4 py-2 text-white rounded-3x1 bg-primary focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>
      </div>
    </div>
  );
}

EditEventModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  evento: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default EditEventModal;
